import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeysDataSubscription } from '../queryKeys';

import { runContactPoint } from './runContactPoint';
import {
  type RunContactPointMutationOptions,
  type RunContactPointVariables,
} from './types';

/**
 * Custom hook for manually running a contact point using mutations.
 *
 * @param options - Additional options for the useMutation hook.
 * @returns An object containing the mutation function and related properties.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Data-Subscription
 */
export const useMutationRunContactPoint = (
  options?: RunContactPointMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ contactPointId, payload }: RunContactPointVariables) =>
      runContactPoint(contactPointId, payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: queryKeysDataSubscription.executionLog(),
      });
    },
    ...options,
  });
};
